import {createAction} from 'web-app/util/redux/typed-action-helpers';

import type * as Types from './types';

const domain = 'MODALS/REPORT_UGC_MODAL';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (payload: {targetId: string; targetType: Types.TargetType}) => payload,
);

export const {action: hide} = createAction(`${domain}/HIDE`, (payload: {didReport: boolean}) => payload);
